
export const FETCH_BOARDS = 'FETCH_BOARDS'
export const FETCH_BOARDS_SUCCESS = 'FETCH_BOARDS_SUCCESS'
export const FETCH_BOARDS_FAILURE = 'FETCH_BOARDS_FAILURE'

export const fetchBoards = (search) => ({
    type: FETCH_BOARDS,
    payload: search
})

export const fetchBoardsSuccess = (boards) => ({
    type: FETCH_BOARDS_SUCCESS,
    payload: boards
})

export const fetchBoardsFailed = (message) => ({
    type: FETCH_BOARDS_FAILURE,
    payload: message
})